<ziro-fieldset-header [legend]="'tkey;shared.model.microsoft_teams_calling.e911_location.header'">
  <ziro-select [fieldId]="'dynamicGeolocations'"></ziro-select>
  <ziro-text [fieldId]="'dynamicGeolocationCallerName'"></ziro-text>
  <ziro-text [fieldId]="'dynamicGeolocationCallbackNumber'"></ziro-text>
  <ziro-select [fieldId]="'dynamicGeolocationPreferredLanguage'"></ziro-select>
  <ziro-text [fieldId]="'dynamicGeolocationEndpointId'"></ziro-text>
</ziro-fieldset-header>
